import { selectRatesInfo } from '@/entities/exchangeRates'
import { cn } from '@/shared/lib/classnames'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { useSelector } from 'react-redux'
import { formatCurrency } from '@/shared/lib/currency'
import { Currencies } from '@/entities/curency'

type Props = {
  currentBalance: number
  currentBalanceFrom: number
  totalBalance?: number
  className?: string
  type: StatisticTabNames
  showRateInfo?: boolean
}

export const AmountInfo = ({ currentBalance, currentBalanceFrom, className, type, showRateInfo = true }: Props) => {
  const { payInRate, payOutRate, lastUpdatedShort } = useSelector(selectRatesInfo)
  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <div className="text-2xl md:text-3xl font-klein font-medium text-text-main dark:text-white">
        {formatCurrency(currentBalance, Currencies.USDT)}
      </div>
      <div className="text-sm md:text-lg text-text-main dark:text-white">
        ~ {formatCurrency(currentBalanceFrom, Currencies.RUB)}{' '}
        {showRateInfo && (
          <span className="text-text-secondary ">
            по курсу {type === 'payIn' ? payInRate : payOutRate} на {lastUpdatedShort}
          </span>
        )}
      </div>
    </div>
  )
}
